import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { UserProfile } from './user-profile.js';

@Entity()
export class Interaction extends MongoEntity {
  static override _class = 'Interaction';
  static override _collectionName = 'interactions';

  @Field(type => String) userId!: string;
  @Field(type => String) organizationId!: string;
  @Field(type => String) type!: string; // 'connection_request' | 'email' | 'dm'
  @Field(type => String) timestamp!: string; // ISO date
  @Field(type => String) campaignId!: string;
}

/**
 * Record an interaction event for tracking.
 * Resolves the user's organizationId from user_profiles.
 */
export async function recordInteraction(
  userId: string,
  type: 'connection_request' | 'email' | 'dm',
  campaignId: string,
  timestamp?: string,
): Promise<void> {
  const profileCol = await getRawCollection(UserProfile._collectionName);
  const profile = await profileCol.findOne({ userId });
  const organizationId = profile?.organizationId ?? '';

  const interactionCol = await getRawCollection(Interaction._collectionName);
  await interactionCol.insertOne({
    userId,
    organizationId,
    type,
    campaignId,
    timestamp: timestamp ?? new Date().toISOString(),
  });
}
